import axios from "axios";
import { isNative, tokenStore } from "@/lib/native";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: !isNative,
});

// Attach Bearer token (native app always; web when third-party cookies are blocked)
api.interceptors.request.use((cfg) => {
  const token = tokenStore.get();
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(undefined, (err) => {
  if (err?.response?.status === 403 && err.response.data?.detail?.code === "EMAIL_NOT_VERIFIED") {
    window.dispatchEvent(new CustomEvent("auk:email-not-verified"));
  }
  return Promise.reject(err);
});

export function fileUrl(fileId) {
  return `${API}/files/${fileId}`;
}

export function formatApiError(detail) {
  if (detail == null) return "Ocorreu um erro. Tenta novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (detail && typeof detail.message === "string") return detail.message;
  return String(detail);
}

export function describeError(err, fallback = "Ocorreu um erro. Tenta novamente.") {
  const res = err?.response;
  if (!res) return err?.code === "ECONNABORTED" ? "O pedido demorou demasiado. Verifica a ligação e tenta novamente." : "Sem ligação ao servidor. Verifica a internet e tenta novamente.";
  const detail = res.data?.detail;
  if (detail != null) return formatApiError(detail);
  const st = res.status;
  if (st === 401) return "Sessão expirada — inicia sessão novamente.";
  if (st === 403) return "Sem permissão para esta acção.";
  if (st === 413) return "Pedido demasiado grande (imagem?). Reduz o tamanho e tenta novamente.";
  if (st === 429) return "Demasiados pedidos — aguarda um momento.";
  if (st >= 500) return `Erro do servidor (${st}). A equipa foi notificada — tenta novamente em instantes.`;
  return `${fallback} (código ${st})`;
}
